import { UserInfoQuery } from '../generated/graphql';

export const getsImport = (user: UserInfoQuery) => {
  if (user.userInfo?.isAdmin) return true;
  return user.userInfo?.isGm || user.userInfo?.isNerd;
};
